import { Link } from 'react-router-dom';

export default function CarsUnder10kCta() {
  return (
    <section className="py-20 bg-gradient-to-br from-[#1C2B1E] via-[#2A3F2E] to-[#1C2B1E] text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-[url('https://public.readdy.ai/ai/img_res/f6beaa62242b446fa6cd1122013f4d5f.jpg')] bg-cover bg-center opacity-10"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Ready to Find Your Perfect Under $10K Vehicle?
          </h2>
          <p className="text-xl md:text-2xl mb-10 text-gray-200">
            Browse our current inventory or get pre-approved for financing today
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Link
              to="/inventory?priceMax=10000"
              className="bg-[#E8B84B] text-[#1C2B1E] px-10 py-4 rounded-lg font-bold text-lg hover:bg-[#d4a43d] transition-all shadow-lg hover:shadow-xl whitespace-nowrap w-full sm:w-auto text-center"
            >
              View Inventory
            </Link>
            <Link
              to="/apply-for-financing"
              className="bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 px-10 py-4 rounded-lg font-bold text-lg hover:bg-white/20 transition-all whitespace-nowrap w-full sm:w-auto text-center"
            >
              Get Pre-Approved
            </Link>
          </div>

          <div className="border-t border-white/20 pt-8">
            <p className="text-lg text-gray-300 mb-4">
              Questions? We're here to help.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center text-[#E8B84B] hover:text-[#d4a43d] font-semibold text-lg transition-colors"
            >
              Contact Us
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}